import React from 'react'
import MyRefetchButton from 'components/ui/MyRefetchButton'

const DataTableToolbar = ({ mutate }) => {
  return (
    <div className="mb-2 flex items-center justify-between gap-2">
      <div className="flex items-center gap-2">
        <MyRefetchButton onClick={() => mutate()} />
      </div>
    </div>
  )
}

export default DataTableToolbar
